<template>
	<div class="home">
		<h1>Welcome to bbok.me</h1>
		<h3>broken but ok's work in process </h3>
	</div>
</template>

<script>
export default {
	name: 'home',
}
</script>

<style lang="stylus" scoped>
h1, h3 
	text-align: center
	padding: 25px 0
	margin: 0
</style>
